export const SALE_PRODUCT_LOAD_SEND_REQUEST = 'SALE_PRODUCT_LOAD_SEND_REQUEST';
export const SALE_PRODUCT_LOAD_SUCCESS_RECEIVE_RESPONSE =
    'SALE_PRODUCT_LOAD_SUCCESS_RECEIVE_RESPONSE';
export const SALE_PRODUCT_LOAD_FAILED_RECEIVE_RESPONSE =
    'SALE_PRODUCT_LOAD_FAILED_RECEIVE_RESPONSE';
